export class CompanyPoolSeasonModel implements ICompanyPoolSeasonModel {
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonName?: string | undefined;
  seasonDescription?: string | undefined;
  defaultPoolExists?: boolean | undefined;

  constructor(data?: ICompanyPoolSeasonModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.seasonNumber = Data["seasonNumber"];
      this.seasonYear = Data["seasonYear"];
      this.seasonName = Data["seasonName"];
      this.seasonDescription = Data["seasonDescription"];
      this.defaultPoolExists = Data["defaultPoolExists"];
    }
  }

  static fromJS(data: any): CompanyPoolSeasonModel {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyPoolSeasonModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["seasonNumber"] = this.seasonNumber;
    data["seasonYear"] = this.seasonYear;
    data["seasonName"] = this.seasonName;
    data["seasonDescription"] = this.seasonDescription;
    data["defaultPoolExists"] = this.defaultPoolExists;
    return data;
  }
}

export interface ICompanyPoolSeasonModel {
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonName?: string | undefined;
  seasonDescription?: string | undefined;
  defaultPoolExists?: boolean | undefined;
}